module.exports = __webpack_public_path__ + "static/media/frames-15.fb590291.jpg";